var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 12C2.75 6.62391 7.12391 2.25 12.5 2.25C17.8761 2.25 22.25 6.62391 22.25 12C22.25 17.3761 17.8761 21.75 12.5 21.75C7.12391 21.75 2.75 17.3761 2.75 12ZM16.2397 15.2015C16.3079 14.9377 16.2277 14.6576 16.0302 14.4698L13.5608 12L16.0302 9.53016C16.3103 9.23528 16.3044 8.77085 16.0168 8.48325C15.7291 8.19564 15.2647 8.1897 14.9698 8.46984L12.5 10.9392L10.0302 8.46984C9.73528 8.1897 9.27085 8.19564 8.98325 8.48325C8.69564 8.77085 8.6897 9.23528 8.96984 9.53016L11.4392 12L8.96984 14.4698C8.6897 14.7647 8.69564 15.2291 8.98325 15.5168C9.27085 15.8044 9.73528 15.8103 10.0302 15.5302L12.5 13.0608L14.9698 15.5302C15.1576 15.7277 15.4377 15.8079 15.7015 15.7397C15.9653 15.6714 16.1714 15.4653 16.2397 15.2015Z",
    fill: "#D2D2D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.86739b2c5b33fbdde67f60736fa0c9da.svg";
export { ForwardRef as ReactComponent };